module.exports = __webpack_public_path__ + "img/coctail-second.948c7303.png";